import { makeStyles } from '@branchjs/neo-components';

export const useStyles = makeStyles((theme) => ({
  workEmail: {
    margin: '48px 0 0 0',
  },
  password: {
    margin: '24px 0 0 0',
  },
  forgotPassword: {
    margin: '24px 0 0 0',
  },
  signIn: {
    margin: '48px 0 0 0',
    display: 'flex',
    gap: '16px',
  },
  buttonSignIn: {
    width: '100%',
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    alignSelf: 'stretch',
    margin: '48px 0 0 0',
    textAlign: 'center',
  },
  gitHubButton: {
    display: 'flex',
    padding: '8px 16px',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '8px',
    background: theme.colors.gray[0],
    '& i': {
      width: '20px',
      height: '20px',
      fontSize: theme.typography.h4.fontSize,
      verticalAlign: 'middle',
      color: 'black',
    },
  },
  showHidePasswordLink: {
    marginLeft: theme.spacing(0.5),
  },
}));
